// admin/bausteine.js – kleine Darstellungshelfer fuer den Verwaltungsbereich.
import React from 'react';

export const datum = (d) =>
  d ? new Date(d).toLocaleDateString('de-CH', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '–';

export const zeit = (d) =>
  d ? new Date(d).toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' }) : '–';

export const datumZeit = (d) => (d ? `${datum(d)}, ${zeit(d)}` : '–');

const FARBEN = {
  gruen: 'bg-green-100 text-green-800 border-green-200',
  rot: 'bg-red-100 text-red-800 border-red-200',
  gelb: 'bg-amber-100 text-amber-800 border-amber-200',
  grau: 'bg-gray-100 text-gray-700 border-gray-200',
  blau: 'bg-blue-100 text-blue-800 border-blue-200',
};

export const Chip = ({ farbe = 'grau', children, title }) => (
  <span
    title={title}
    className={`inline-block px-2 py-0.5 rounded text-xs font-medium border ${FARBEN[farbe]}`}
  >
    {children}
  </span>
);

/** Zustellstatus einfaerben: "accepted" heisst nur angenommen, nicht zugestellt. */
export const ZustellChip = ({ status }) => {
  if (!status) return <span className="text-gray-400">–</span>;
  const farbe = {
    read: 'gruen', delivered: 'gruen', sent: 'blau',
    accepted: 'gelb', failed: 'rot', undelivered: 'rot',
  }[status] || 'grau';
  const titel = status === 'accepted'
    ? 'Vom Anbieter angenommen – ob sie ankam, ist damit noch nicht gesagt'
    : undefined;
  return <Chip farbe={farbe} title={titel}>{status}</Chip>;
};

export const ZahlChip = ({ status }) => {
  const farbe = { paid: 'gruen', pending: 'gelb', past_due: 'rot',
    canceled: 'grau', unpaid: 'rot' }[status] || 'grau';
  return <Chip farbe={farbe}>{status}</Chip>;
};

export const Karte = ({ titel, rechts, children }) => (
  <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
    {(titel || rechts) && (
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
        <h2 className="font-semibold text-gray-900">{titel}</h2>
        {rechts}
      </div>
    )}
    <div className="p-5">{children}</div>
  </div>
);

export const Leer = ({ children }) => (
  <p className="text-sm text-gray-500 py-4 text-center">{children}</p>
);

export const Fehler = ({ children }) =>
  children ? (
    <div role="alert" className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-3 text-sm">
      {children}
    </div>
  ) : null;
